import React, { lazy } from 'react'
import Loadable from 'app/components/Loadable/Loadable';

const Analytics = Loadable(lazy(() => import("./Analytics")));
const Users = Loadable(lazy(() => import("./users")));
// const UserActivity = Loadable(lazy(() => import("./UserActivity")));
const UserLog = Loadable(lazy(() => import("./UserLog")));


const Participants = Loadable(lazy(() => import("./Participants")));

const Scans = Loadable(lazy(() => import("./Scans")));
const Transactions = Loadable(lazy(() => import("./Transactions")));
const Raffles = Loadable(lazy(() => import("./Raffles")));
const RaffleDetails = Loadable(lazy(() => import("./Raffles/details")));
const Exhibitors = Loadable(lazy(() => import("./Exhibitors")));
const ExhibitorsDetails = Loadable(lazy(() => import("./Exhibitors/details")));
const Settings = Loadable(lazy(() => import("./Settings")));

const dashboardRoutes = [
    {
        path: '/raffles',
        element: <Raffles />,
    },
    {
        path: '/raffles/:id',
        element: <RaffleDetails />,
    },
    {
        path: '/raffles/new',
        element: <RaffleDetails />,
    },
    {
        path: '/exhibitors',
        element: <Exhibitors />,
    },
    {
        path: '/exhibitors/:id',
        element: <ExhibitorsDetails />,
    },
    {
        path: '/exhibitors/new',
        element: <ExhibitorsDetails />,
    },
    {
        path: '/participants',
        element: <Participants />,
    },
    {
        path: '/scans',
        element: <Scans />,
    },
    {
        path: '/transactions',
        element: <Transactions />,
    },
    {
        path: '/users',
        element: <Users />,
    },
    {
        path: '/settings',
        element: <Settings />,
    },
    {
        path: '/userlogs',
        element: <UserLog />,
    },
]

export default dashboardRoutes
